<template>
  <div class="collect">
    <el-dialog :title="isGaonS?isEnglish?'Collection':'收藏':'收藏'" :visible.sync="isShow" width="50%">
      <div class="filderContainer" v-if="folderList.length">
        <div
          class="filder"
          v-for="(item,index) in folderList"
          :key="item.id"
          @click="choceThis(item, index)"
        >
          <div></div>
          <p>{{isGaonS?(isEnglish&&((item.name||'').indexOf('*##*')!=-1)?(item.name||'').split('*##*')[1]:(item.name||'').split('*##*')[0]):item.name}}</p>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="folder.total"
          :current-page.sync="page"
          :page-size="folder.per_page - 0"
        ></el-pagination>
      </div>
      <div v-else>
        <p>{{isGaonS?isEnglish?"Create and bookmark to":"创建并收藏到":"创建并收藏到"}}</p>
        <el-input v-model="collectName"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShow = false">{{isGaonS?isEnglish?"Cancel":"取 消":"取 消"}}</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="submit"
        >{{isGaonS?isEnglish?"Certain":"确 定":"确 定"}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import {
  getFavoriteList,
  getFavoriteItem,
  addFavorite,
  addFavoriteAsset
} from "@/services/api";
export default {
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    },
    assetType: {
      type: Number,
      default() {
        return 1;
      }
    },
    choceImg: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      page: 1,
      folder: {},
      folderList: [],
      curFolder: "",
      collectName: ""
    };
  },
  computed: {
    ...mapGetters(["isGaonS", "isEnglish"]),
    isShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  watch: {
    page: {
      handler(val) {
        this.getFavoriteList();
      },
      immediate: false
    }
  },
  created() {
    this.getFavoriteList();
  },
  methods: {
    choceThis(item, num) {
      this.curFolder = item.id;
      document.querySelectorAll(".filder").forEach((item, index) => {
        if (index == num) {
          item.className = "filder activeFilder";
        } else {
          item.className = "filder";
        }
      });
    },
    submit() {
      if (this.folderList.length) {
        var that = this;
        let data = [];
        if (this.choceImg.toString().indexOf(",") > -1) {
          let ids = this.choceImg.split(",");
          ids.forEach(item => {
            data.push({
              assetId: item - 0,
              favoriteId: this.curFolder
            });
          });
        } else {
          data = [
            {
              assetId: this.choceImg - 0,
              favoriteId: this.curFolder
            }
          ];
        }
        addFavoriteAsset(data).then(res => {
          if (res.status_code == 1) {
            this.$message.success(
              this.isGaonS
                ? this.isEnglish
                  ? "Successful collection"
                  : "收藏成功"
                : "收藏成功"
            );
            this.isShow = false;
            that.$parent.$parent.changeicon = false;
          } else {
            this.$message.error(
              this.isGaonS
                ? this.isEnglish
                  ? "Collection failed"
                  : "收藏失败"
                : "收藏失败"
            );
          }
        });
      } else {
        let data = {
          favoriteName: this.collectName,
          type: this.assetType
        };
        addFavorite(data).then(res => {
          if (res.status_code == 1) {
            let Data = {
              assetId: this.choceImg - 0,
              favoriteId: res.data.id - 0
            };
            addFavoriteAsset([Data]).then(res => {
              if (res.status_code == 1) {
                this.$message.success("收藏成功");
                this.isShow = false;
                that.$parent.$parent.changeicon = false;
              } else {
                this.$message.error("收藏失败");
              }
            });
          } else {
            this.$message.error("创建收藏夹失败");
          }
        });
      }
    },
    getFavoriteList() {
      let userInfo = sessionStorage.getItem("user");
      if (!userInfo) {
        this.$message.error("请登录后重试");
      } else {
        let data = {
          favoriteType: this.assetType,
          page: this.page
        };
        getFavoriteList(data).then(res => {
          if (res.status_code == 1) {
            this.folder = res.data;
            this.folderList = res.data.data;
          }
        });
      }
    }
  }
};
</script>
<style lang="less">
.collect {
  .filderContainer {
    position: relative;
    width: 100%;
    margin: 0 auto;
    &::after {
      content: "";
      width: 0;
      height: 0;
      display: block;
      clear: both;
    }
    .filder {
      width: 88px;
      height: 70px;
      float: left;
      margin: 10px;
      border: 2px solid #ffffff;
      cursor: pointer;
      div {
        width: 88px;
        height: 50px;
        background: url("./../assets/images/folder.png") no-repeat center;
      }
      p {
        text-align: center;
        line-height: 20px;
        font-size: 12px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .activeFilder {
      border: 2px solid #409eff;
    }
    .el-pagination {
      position: absolute;
      bottom: -30px;
      right: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collect.vue